import Hammer from "hammerjs";

import { RatingValue } from "@/data/model/Enums";
import { Misc } from "@/data/util/Misc";

export class StarRating {
    private $element: JQuery;
    private value?: RatingValue;

    public onChange?: { (rating: RatingValue | undefined) };
    private touchCtrl: HammerManager;
    constructor() {
        this.$element = $('<div class="starrating" />');

        Misc.eachEnum(RatingValue, (i) => {
            $('<div class="star"><i class="fal fa-star"></i></div>')
                .data("model", i)
                .appendTo(this.$element)
                .click((e) => {
                    e.preventDefault();
                    this.onClickStar($(e.currentTarget));
                });
        });

        this.touchCtrl = new Hammer(this.$element[0], {
            recognizers: [[Hammer.Pan, { direction: Hammer.DIRECTION_HORIZONTAL, threshold: 0 }]],
        });

        const stars = this.$element.find("> .star");

        let starEachPoint;
        let leftOffset;

        this.touchCtrl.on("panstart", () => {
            starEachPoint = stars.length / this.$element.width();
            leftOffset = this.$element.position().left;
        });

        this.touchCtrl.on("panmove", (ev) => {
            const offset = ev.center.x - leftOffset;
            let activeStar: RatingValue = Math.floor(starEachPoint * offset);
            if (activeStar < 0) this.setValue();
            else {
                if (activeStar > stars.length - 1) activeStar = stars.length - 1;

                this.setValue(activeStar);
            }
        });
    }

    private onClickStar($star: JQuery) {
        this.setValue($star.data("model"));
    }

    public setValue(v?: RatingValue): StarRating | void {
        if (this.value === v) return;

        if (v === undefined) this.$element.find(".fa-star").addClass("fal").removeClass("fas");
        else {
            this.$element.children().each((i, e) => {
                const s = $(e);
                if (i > v) s.find("> .fa-star").addClass("fal").removeClass("fas");
                else s.find("> .fa-star").addClass("fas").removeClass("fal");
            });
        }

        this.value = v;
        if (this.onChange !== undefined) this.onChange(v);

        return this;
    }

    public reset() {
        this.value = undefined;
        this.$element.find(".fas").removeClass("fas").addClass("fal");
    }

    public getValue(): RatingValue | undefined {
        return this.value;
    }

    public appendTo($element: JQuery): StarRating {
        this.$element.appendTo($element);

        return this;
    }

    public destroy() {
        this.touchCtrl.destroy();
    }
}
